/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { sendEventToOptimusBackend } from '../../api/onboardingAPI';
import {
  InvoiceSimpleSolutionOrgName,
  JoistSolutionOrgName,
  KickservSolutionOrgName,
  MarketSharpSolutionOrgName,
  ImproveIt360SolutionOrgName,
  RoofsnapSolutionOrgName,
  ServiceFusionSolutionOrgName,
  SolutionOrgName,
  EverProEdgePublicSolutionOrgName,
  ServiceNationSolutionOrgName,
} from '../../common/constants';
import { OptimusEvent } from '../../common/EventTrackingTypes';
import { RootState } from '../storeSetup';

export const sendOnboardingEventToOptimusBackendThunk = createAsyncThunk<
// Return type of the payload creator
void,
// First argument to the payload creator
{ optimusEvents: OptimusEvent[], solutionOrg: SolutionOrgName },
// Types for ThunkAPI
{
  state: RootState
}>(
  'event/sendOnboardingEventToOptimusBackend',
  async ({ optimusEvents, solutionOrg }, { getState }) => {
    let eventPath = '';
    if (solutionOrg === JoistSolutionOrgName) {
      eventPath = 'joist-onboarding';
    } else if (solutionOrg === ServiceFusionSolutionOrgName) {
      eventPath = 'service-nation-onboarding';
    } else if (
      solutionOrg === InvoiceSimpleSolutionOrgName ||
        solutionOrg === RoofsnapSolutionOrgName ||
        solutionOrg === KickservSolutionOrgName ||
        solutionOrg === MarketSharpSolutionOrgName ||
        solutionOrg === ImproveIt360SolutionOrgName
    ) {
      eventPath = 'everpro-onboarding';
    } else if (
      solutionOrg === EverProEdgePublicSolutionOrgName ||
      solutionOrg === ServiceNationSolutionOrgName
    ) {
      eventPath = 'service-nation-onboarding';
    }
    await sendEventToOptimusBackend(optimusEvents, eventPath);
  },
);

export const sendContentEventToOptimusBackendThunk = createAsyncThunk<
// Return type of the payload creator
void,
// First argument to the payload creator
OptimusEvent[],
// Types for ThunkAPI
{
  state: RootState
}>(
  'event/sendContentEventToOptimusBackend',
  async (optimusEvents, { getState }) => {
    await sendEventToOptimusBackend(optimusEvents, 'content');
  },
);

export const sendFeedEventToOptimusBackendThunk = createAsyncThunk<
// Return type of the payload creator
void,
// First argument to the payload creator
OptimusEvent[],
// Types for ThunkAPI
{
  state: RootState
}>(
  'event/sendContentEventToOptimusBackend',
  async (optimusEvents, { getState }) => {
    await sendEventToOptimusBackend(optimusEvents, 'feed');
  },
);
export const sendSearchEventToOptimusBackendThunk = createAsyncThunk<
// Return type of the payload creator
void,
// First argument to the payload creator
OptimusEvent[],
// Types for ThunkAPI
{
  state: RootState
}>(
  'event/sendContentEventToOptimusBackend',
  async (optimusEvents, { getState }) => {
    await sendEventToOptimusBackend(optimusEvents, 'search');
  },
);

export const sendSessionEventToOptimusBackendThunk = createAsyncThunk<
// Return type of the payload creator
void,
// First argument to the payload creator
OptimusEvent[],
// Types for ThunkAPI
{
  state: RootState
}>(
  'event/sendSessionEventToOptimusBackend',
  async (optimusEvents, { getState }) => {
    await sendEventToOptimusBackend(optimusEvents, 'session');
  },
);
